export const Avatar = {
    sizes: {
        // structure from https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%401.8.8/packages/theme/src/components/avatar.ts#L49-L66
        '3xl': {
            container: {
                width: 40,
                height: 40,
                fontSize: 'calc(10rem / 2.5)'
            },
            excessLabel: {
                width: 40,
                height: 40
            },
            label: {
                fontSize: 'calc(10rem / 2.5)',
                lineHeight: '10rem'
            }
        }
    },
    variants: {
        outline: {
            container: {
                bg: 'transparent',
                borderWidth: 3,
                p: 0.5
            }
        }
    },
    defaultProps: {
        variant: 'default',
        size: 'md'
    }
};

//# sourceMappingURL=avatar.js.map